class RiseHeader extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('[data-rise-nav-toggle]');
    this.links = this.querySelector('[data-rise-nav-links]');
    this.backdrop = this.querySelector('[data-rise-nav-backdrop]');
    this.header = this.querySelector('[data-rise-header]');

    this.toggle?.addEventListener('click', () => {
      const open = !this.links?.classList.contains('is-open');
      this.setMobileNav(open);
    });

    this.backdrop?.addEventListener('click', () => {
      this.setMobileNav(false);
    });

    this.querySelector('[data-rise-nav-close]')?.addEventListener('click', () => {
      this.setMobileNav(false);
      this.toggle?.focus();
    });

    document.addEventListener('keydown', this.onKeydown);

    this.links?.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        this.setMobileNav(false);
      });
    });

    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.onScroll();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    document.removeEventListener('keydown', this.onKeydown);
    document.body.style.overflow = '';
  }

  onKeydown = (event) => {
    if (event.key === 'Escape' && this.links?.classList.contains('is-open')) {
      this.setMobileNav(false);
      this.toggle?.focus();
    }
  };

  onScroll = () => {
    const scrolled = window.scrollY > 20;
    this.classList.toggle('is-scrolled', scrolled);
    this.header?.classList.toggle('is-scrolled', scrolled);
  };

  setMobileNav(open) {
    this.toggle?.classList.toggle('is-active', open);
    this.links?.classList.toggle('is-open', open);
    this.backdrop?.classList.toggle('is-open', open);
    this.toggle?.setAttribute('aria-expanded', open ? 'true' : 'false');
    this.toggle?.setAttribute('aria-label', open ? 'Fechar menu' : 'Abrir menu');
    document.body.style.overflow = open ? 'hidden' : '';
  }
}

if (!customElements.get('rise-header-component')) {
  customElements.define('rise-header-component', RiseHeader);
}
